/** 스토어 필터 드로어의 DOM id — 툴바의 "필터" 버튼이 aria-controls 로 가리킨다. */
export const STORE_FILTER_DRAWER_ID = 'store-filter-drawer';

/** 상품 상세의 섹션 DOM id — 우측 패널의 바로가기 탭(제작 정보 | 수량별 가격 | 상세 설명)이 가리킨다. */
export const STORE_DETAIL_INFO_ID = 'store-production-info';
export const STORE_DETAIL_PRICE_TIERS_ID = 'store-price-tiers';
export const STORE_DETAIL_DESCRIPTION_ID = 'store-detail-description';
export const STORE_DETAIL_PROCESS_ID = 'store-detail-process';
export const STORE_DETAIL_REVIEWS_ID = 'store-detail-reviews';
